import { ProvinceCreate } from '../components/Province/ProvinceCreate';
import { ProvinceEdit } from '../components/Province/ProvinceEdit';
import { ProvinceList } from '../components/Province/ProvinceList';

export const Provinces = {
  create: ProvinceCreate,
  edit: ProvinceEdit,
  list: ProvinceList,
};
